module.exports = __webpack_public_path__ + "static/media/google-play-mobile.f79aeb57.svg";